<template>
  <div>
    <search-box
      :columns="searchBoxColumns"
      @search="search"
      @btnReset="handleReset"
      :defaultValue="formData"
      :column="2"
      />

    <QS-common-table
      :data="tableData"
      :columns="tableColumns"
      row-key="id"
      :pagination="paginationData"
      @change="paginationChange"
      v-loading="tableLoading"
    />

    <bind-scheme-dialog
    :dialogVisible="bindSchemeVisible"
    :planRow="planRow"
    @close="handleCloseBindSchemeDialog"
    />
    <bind-order-dialog
    :dialogVisible="bindOrderVisible"
    :planRow="planRow"
    @close="handleCloseBindOrderDialog"
    />
    <abnormal-dialog
    :id="id"
    :abnormalVisible="abnormalVisible"
    :abnormalData="abnormalData"
    @close="handleCloseAbnormalDialog"
    :bindType="bindType"
    />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import config from './config'
// eslint-disable-next-line import/no-cycle
import {
  maintenancePageListApi,
  maintenanceStoreListAllCityApi,
  maintenanceLikeByNameApi,
  getCompanyProviderLikeByNameApi,
} from './services'
import bindSchemeDialog from './components/bindSchemeDialog/index.vue'
import abnormalDialog from './components/abnormalDialog.vue'
import bindOrderDialog from './components/bindOrderDialog/index.vue'

export default {
  name: 'maintenanceProject',
  components: {
    bindSchemeDialog,
    abnormalDialog,
    bindOrderDialog,
  },
  data() {
    const { searchBoxColumns, tableColumns, abnormalData } = config.call(this)
    return {
      searchBoxColumns,
      tableData: [],
      tableColumns,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      formData: {},
      tableLoading: false,
      bindSchemeVisible: false,
      bindOrderVisible: false,
      planRow: {},
      abnormalVisible: false,
      abnormalData,
      abnormalTableData: [],
      bindType: 'order',
      id: '',
    }
  },
  methods: {
    handleReset() {
      this.formData = {}
      this.tableData = []
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.getmaintenancePageList()
    },
    // searchBox
    search(formData) {
      this.formData = formData
      this.paginationData.pageSize = 10
      this.paginationData.pageNum = 1
      this.getmaintenancePageList()
    },
    // 分页
    paginationChange(payload) {
      const {
        pagination: { pageSize, pageNum },
      } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.getmaintenancePageList()
    },
    getProjectNames(e) {
      this.getMaintenanceLikeByNameApi(e)
    },
    getCompanyProviderName(e) {
      this.getCompanyProviderLikeByName(e)
    },
    // 详情
    // eslint-disable-next-line vue/no-unused-properties
    openDetailPage(row) {
      this.$router.push({
        path: '/vehicle/maintenance/maintenanceProject_detail',
        query: {
          orderId: row.id,
          collaborationId: row.collaborationId,
        },
      })
    },
    // 采购→服务商管理→维保入驻审核，搜索指定ID
    // eslint-disable-next-line vue/no-unused-properties
    openCollaborationPage(row) {
      this.$router.push({
        path: '/purchaseNew/maintenanceReview/list',
        query: {
          id: row.collaborationId,
        },
      })
    },
    // 采购→服务商管理→维保入驻审核，搜索指定ID
    // eslint-disable-next-line vue/no-unused-properties
    openservicePage(row) {
      this.$router.push({
        path: '/purchaseNew/serviceProvider/list',
        query: {
          serviceId: row.serviceId,
        },
      })
    },
    // 绑定租赁方案
    // eslint-disable-next-line vue/no-unused-properties
    bindPlanDialog(row) {
      this.bindType = 'scheme'
      this.planRow = row
      this.id = row.id
      this.bindSchemeVisible = true
    },
    /**
     * @param {*} isAbnormal 是否异常
     * @param {*} abnormalTableData 异常数据
     */
    handleCloseBindSchemeDialog(isAbnormal, abnormalTableData) {
      this.abnormalTableData = abnormalTableData
      if (isAbnormal === true) {
        this.abnormalData.get(this.bindType).data = this.abnormalTableData
        this.abnormalVisible = true
      } else {
        this.bindSchemeVisible = false
        this.planRow = {}
        this.abnormalTableData = []
      }
    },
    handleCloseAbnormalDialog() {
      this.abnormalData.get(this.bindType).data = []
      this.abnormalVisible = false
      this.abnormalTableData = []

      this.bindSchemeVisible = false
      this.bindOrderVisible = false
    },
    // 绑定租赁订单
    // eslint-disable-next-line vue/no-unused-properties
    bindOrderDialog(row) {
      this.bindType = 'order'
      this.planRow = row
      this.id = row.id
      this.bindOrderVisible = true
    },
    // 关闭租赁订单dialog
    handleCloseBindOrderDialog(isAbnormal, abnormalTableData) {
      this.abnormalTableData = abnormalTableData
      if (isAbnormal === true) {
        this.abnormalData.get(this.bindType).data = this.abnormalTableData
        this.abnormalVisible = true
      } else {
        this.bindOrderVisible = false
        this.planRow = {}
        this.abnormalTableData = []
      }
    },
    // 项目列表查询
    async getmaintenancePageList() {
      const [err, _data] = await this.$to(maintenancePageListApi({
        ...this.formData,
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      }))
      this.tableLoading = false

      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.paginationData.total = data.totalNum
          this.tableData = data.items
        }
      }
    },
    // 获取适用城市
    async getMaintenanceStoreListAllCity() {
      const [err, _data] = await this.$to(maintenanceStoreListAllCityApi())
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'cityCode') {
              item.source = cloneDeep(data)
            }
            return item
          })
        }
      }
    },
    // 项目名称模糊查询
    async getMaintenanceLikeByNameApi(name) {
      const [err, _data] = await this.$to(maintenanceLikeByNameApi({ name }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'id') {
              const newData = data.map((ite) => {
                ite.name += `(${ite.id})`
                return ite
              })
              item.source = cloneDeep(newData)
            }
            return item
          })
        }
      }
    },
    // 获取服务商名称
    async getCompanyProviderLikeByName(name) {
      const [err, _data] = await this.$to(
        getCompanyProviderLikeByNameApi({ name }),
      )
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          this.searchBoxColumns = this.searchBoxColumns.map((item) => {
            if (item.key === 'serviceId') {
              const newData = data.map((ite) => {
                ite.name += `(${ite.id})`
                return ite
              })
              item.source = cloneDeep(newData)
            }
            return item
          })
        }
      }
    },
  },
  created() {
    const { id } = this.$route.query
    if (this.$route.query.categoryId) {
      this.formData.categoryId = Number(this.$route.query.categoryId)
    }
    this.formData.id = id
    // 获取table列表
    this.getmaintenancePageList()
    // 获取适用城市
    this.getMaintenanceStoreListAllCity()
    // 获取项目名称
    this.getProjectNames()
    // 获取合作服务商
    this.getCompanyProviderName()
  },
}
</script>

<style lang="scss" scoped></style>
